import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, useIntl } from "react-intl"
import { RadioGroupStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupStep"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"

const adoptingSpouseChildOptions = [
  { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
  { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
]

export function RelatedToAdoptingSpouseChildStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { isStepchildAdoption }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const formattedOptions = useConvertTranslatedLabel(adoptingSpouseChildOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({
      type: "UPDATE_FIELD",
      field: "isStepchildAdoption",
      value: formValues.isStepchildAdoption
    })
    send("")
  }

  return (
    <RadioGroupStep
      title={intl.formatMessage({
        defaultMessage: "Is this related to adopting a spouse's child (stepparent adoption)?"
      })}
      description={intl.formatMessage({
        defaultMessage: "We need this information to process your expense correctly."
      })}
      name="isStepchildAdoption"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={isStepchildAdoption}
    />
  )
}
